import { useSavedAccount } from "@saleor/components/AppLayout/SavedAccountContext";
import useNavigator from "@saleor/hooks/useNavigator";
import React, { useEffect } from "react";

import LoginSavedAccount from "../components/LoginSavedAccount";
import { userLoginPath } from "../urls";
const ChooseAccount: React.FC = () => {
  const { savedAccounts } = useSavedAccount();
  const navigate = useNavigator();

  useEffect(() => {
    if (savedAccounts.length === 0) {
      navigate(userLoginPath);
    }
  }, [savedAccounts]);

  return <LoginSavedAccount />;
};
ChooseAccount.displayName = "ChooseAccount";
export default ChooseAccount;
